import React, { useEffect } from "react";
import s from "../layers-menu.module.scss";
import { Layer } from "../../../../interfaces/layer";
import { DebouncedFunction } from "../../useDebounceLayers";
import RadioButton from "../../../ui-kit/radio-button/radio-button";

interface Props {
  radioLayers: Layer[];
  debounce: DebouncedFunction;
  handleChangeSelectedItems: (
    id: number,
    checked: boolean,
    type: "radio",
  ) => void;
  selectedRadioId: number;
  allSelected: number[];
}

export default function RadioButtons({
  radioLayers,
  debounce,
  handleChangeSelectedItems,
  selectedRadioId,
  allSelected,
}: Props) {
  const layersIdx = radioLayers.map((item) => item.id);
  useEffect(() => {
    if (selectedRadioId) debounce(selectedRadioId, true, "radio", layersIdx);
  }, [selectedRadioId]);

  return (
    <div className={s.radioButtonsContainer}>
      {radioLayers.map((item, idx) => (
        <RadioButton
          value={item.label}
          key={idx}
          name="map"
          checked={allSelected.includes(item.id)}
          onChange={() => {
            debounce(item.id, true, "radio", layersIdx);
            handleChangeSelectedItems(item.id, true, "radio");
          }}
          label={item.label}
        />
      ))}
    </div>
  );
}
